var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"aff-embed-section"},[_c('div',{staticClass:"aff-embed-container"},[_c('router-view',{on:{"loading":_vm.changeLoading}}),_c('Loading'),_c('Error')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }